


































/* eslint-disable vue/prop-name-casing */
import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { getCategoryCarouselLink } from '@shared/helpers/category/getCategory';
import { IStoryblokShopifyCategory } from '@shared/types/storyblok';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

import CardSection from '~/components/CardSection/CardSection.vue';
import CategoryCardFlat from '~/components/CategoryCardFlat/CategoryCardFlat.vue';

export default defineComponent({
  name: 'PopularCategoriesCarousel',
  components: {
    CardSection,
    CategoryCardFlat,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    categories: {
      type: Array as PropType<IStoryblokShopifyCategory[]>,
      default: () => [],
    },
  },
  setup() {
    return {
      getStoryblokImageURL,
      getCategoryCarouselLink,
    };
  },
});
